module.exports = __webpack_public_path__ + "static/media/cone.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/default/cone.svg
// module id = 57
// module chunks = 0